import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { ServiceDetailModel } from 'src/app/models/rental/service-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceDetailService {

  constructor(private _httpClient: HttpClient) { }

  createServiceDetail(serviceDetailContract: ServiceDetailModel): Observable<ServiceDetailModel> {
    return this._httpClient.post<ServiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.CreateServiceDetail}`,
      serviceDetailContract);
  }

  deleteSomeDetails(serviceDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.DeleteSomeDetails}`, serviceDetailIds);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllConceptsInvoicingForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetAllConceptsInvoicingForSelectAsync}`,);
  }

  getAllServiceDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetAllServiceDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllUnitsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetAllUnitsForSelectAsync}`,);
  }

  getArticlesForDetailsAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticleSelectionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticleSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetArticlesForDetailsAsync}`,
      filters, { params: params }
    );
  }

  getClientValue(costCenterId: number, articleId: number): Observable<CostCenterPriceModel> {
    return this._httpClient.get<CostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetClientValue}/${costCenterId}/${articleId}`);
  }

  getColumnsForArticles(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetColumnsForArticles}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetColumnsForGeneralConsultationAsync}`);
  }

  getServiceDetailById(serviceDetailId: number): Observable<ServiceDetailModel> {
    return this._httpClient.get<ServiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetServiceDetailById}/${serviceDetailId}`);
  }

  getServiceDetailByServiceId(serviceId: number): Observable<Array<ServiceDetailModel>> {
    return this._httpClient.get<Array<ServiceDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetServiceDetailsByServiceId}/${serviceId}`);
  }

  getServiceDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, serviceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('serviceId', serviceId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetServiceDetailsForCaptureTableAsync}`,
      { params: params }
    );
  }

  updateServiceDetail(serviceDetailContract: ServiceDetailModel): Observable<ServiceDetailModel> {
    return this._httpClient.put<ServiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.UpdateServiceDetail}`,
      serviceDetailContract);
  }

  getServiceDetailByKeys(serviceId: number, articleId: number): Observable<ServiceDetailModel> {
    const params = new HttpParams().set('serviceId', serviceId).set('articleId', articleId);
    return this._httpClient.get<ServiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.serviceDetail.GetServiceDetailByKeysAsync}`,
      { params: params }
    );
  }

}
